import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PROFILE_NAV_ITEMS, type ProfileTabKey } from "./types";

const DEFAULT_TAB: ProfileTabKey = "profile";

const VALID_TAB_KEYS = new Set<string>(PROFILE_NAV_ITEMS.map((item) => item.key));

const isProfileTabKey = (value: string): value is ProfileTabKey => VALID_TAB_KEYS.has(value);

export const useProfileActiveTab = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo<ProfileTabKey>(() => {
    const hash = location.hash.replace(/^#/, "");
    return isProfileTabKey(hash) ? hash : DEFAULT_TAB;
  }, [location.hash]);

  // replace: true keeps tab switches from piling up browser history entries.
  const setActiveTab = useCallback(
    (tab: ProfileTabKey) => {
      navigate(
        { pathname: location.pathname, search: location.search, hash: `#${tab}` },
        { replace: true }
      );
    },
    [navigate, location.pathname, location.search]
  );

  return { activeTab, setActiveTab };
};
